import request from '@/utils/request'

// 取得选定时间内首次完成审核订单列表
export function getFirstAuditOrderList(params) {
  return request({
    url: '/service/v1/ums/Auditor/getFirstAuditOrderList',
    method: 'get',
    params,
  })
}

// 取得每日每小时审核量
export function getAuditHourlyCountPerDay(params) {
  return request({
    url: '/service/v1/ums/Auditor/getAuditHourlyCountPerDay',
    method: 'get',
    params,
  })
}

// 汇出审核员数据统计
export function exportAuditorStatistics(params) {
  return request({
    responseType: 'blob',
    url: '/service/v1/ums/Auditor/exportAuditorStatistics',
    method: 'get',
    params,
  })
}

// 审核员数据
export function auditorCount(params) {
  return request({
    url: '/service/v1/ums/Auditor/count',
    method: 'get',
    params: params,
  })
}

// 获得通道型代理数据汇总 by 天
export function getStatisticsChannel(params) {
  return request({
    url: '/service/v1/ums/channel/count/countByDay',
    method: 'get',
    params: params,
  })
}

// 获得通道型代理数据汇总
export function channelCount(params) {
  return request({
    url: '/service/v1/ums/channel/count',
    method: 'get',
    params: params,
  })
}

export function operatorCount(params) {
  return request({
    url: '/service/v1/ums/Operator/count',
    method: 'get',
    params: params,
  })
}

// 獲得代理統計(byDate)
export function getAgentCountByDate(params) {
  return request({
    url: '/service/v1/ums/angent/count/getAgentCountByDate',
    method: 'get',
    params,
  })
}


// WEBPACK FOOTER //
// ./src/api/service.js